<template>
  <div>
     <div class="xsmall-hide small-hide bg-1">
    </div>
    <div class="medium-hide large-hide xlarge-hide">
      <img src="../assets/naniungo-2.jpg">
    </div>
    <div class="md-layout mt-20"
         style="margin-left:10vw; margin-right:10vw">
      <div class="md-layout-item">
        <h1>Unternehmensberatung neu definiert</h1>
        <div class="sub">
          Agil – persönlich – kompetent
        </div>
        <p>
          Wir vermitteln Spezialisten für kaufmännische Projekte, Top Kandidaten in der Festanstellung und Meinungsbildner für mehr Präsenz im Social Media Marketing. Schnell und zuverlässig!
Wir fungieren als Sparringspartner und sorgen mit innovativen Konzepten und fundierter Expertise für die Optimierung Ihrer crossmedialen Kernprozesse, der Unternehmensstrategien sowie der Ressourcen-Nutzung. Unsere Beratungen sind maßgeschneidert, da wir der Meinung sind, jedes Unternehmen ist individuell und benötigt individuelle Beratung. Mit unserem Know-how unterstützen wir Sie gern in Bereichen wie der Vermittlung von Fach- und Führungskräften, der erfolgreichen Gestaltung von Projekten und der Abfederung von Spitzen im Projektgeschäft sowie bei der Optimierung bestehender Prozesse und –strategien. Unser Fokus erstreckt sich hierbei von der erfolgreichen Unterstützung im Aufbau von Shared Service Organisationen, BPO (Business Process Outsourcing), M&A (Mergers & Acquisitions), Projektmanagement und Reorganisationen.  
        </p>
        <p>
          Wir arbeiten eng mit Privat Equity Unternehmen, stark wachsenden oder sich verschlankenden Organisationen aller Größenordnungen zusammen. Überall da, wo Sie fehlendes Know-how haben, sich eine externe Sicht auf Ihre Themen wünschen oder Sie zupackende Hände benötigen, kommen wir ins Spiel. Mit höchster Geschwindigkeit, dem richtigen Gespür für Experten und Organisationen und den modernsten Tools und Techniken lösen wir gemeinsam Ihre Herausforderungen. Denn eines sollte klar sein: In Zeiten der Digitalisierung darf hohe Flexibilität und ein stabiles Changemanagement nicht fehlen. 
        </p>
        <p>
          <strong>Unsere Werte sind Ihre Mehrwerte</strong>
          <br>
          Was macht naniungo so einzigartig? Warum können Sie mit naniungo nur profitieren? Es sind die Menschen, die den Unterschied ausmachen. Menschen – die begeistern. Unsere Mitarbeiter und branchenführende Experten sind unser ganzer Stolz und geben Tag für Tag alles, um mit Ihnen gemeinsam noch weiter nach vorne zu kommen. Mit Expertise und Energie helfen wir Ihnen, sich auf das Wesentliche zu konzentrieren und eine starke Organisation aufzubauen. Gegenseitige Wertschätzung, Respekt, Leidenschaft und die Freude an der Zusammenarbeit haben wir verinnerlicht. Durch die langjährige Erfahrung in unterschiedlichsten Bereichen und die innere Motivation, den höchsten Standard zu setzen, machen wir Sie und Ihr Unternehmen erfolgreich. 
        </p>
      </div>
    </div>
    <div class="md-layout mt-100"
         style="margin-left:10vw; margin-right:10vw;">
      <div class="md-layout-item">

      <h1>Management</h1>
          <div class="sub">
          Unverwechselbar durch Erfahrung - Leidenschaft - Engagement
        </div>
        <p>
          Gemeinsam mit unserem Team sind wir permanent auf der Suche nach Herausforderungen. Individuelles, selbstständiges und eigenverantwortliches Handeln werden bei uns ebenso großgeschrieben wie Teamarbeit und netzwerkübergreifende Kooperation mit weiteren Experten. Die beiden Mitglieder des Managements Nicole Ziegler und Henrik Deitinghoff bringen fundierte Ausbildungen und Studien in den Bereichen Marketing, Logistik, Finanzen und IT sowie Prozess- und Projektmanagement mit ein. Darüber hinaus verfügen sie über zahlreiche Jahre an Berufserfahrung in renommierten Positionen in den Bereichen Personalberatung, Bewerbermanagement und Vertrieb.
        </p>
    </div>
    </div>
    <div class="md-layout mt-20"
         style="margin-left:10vw; margin-right:10vw">
      <div class="md-layout-item mt-40 md-xlarge-size-40 md-large-size-40 md-medium-size-40 md-small-size-100 md-xsmall-size-100">
        <img src="../assets/about-nicole.jpg">
      </div>
      <div class="md-layout-item blog-margin md-xlarge-size-60 md-large-size-60 md-medium-size-60 md-small-size-100 md-xsmall-size-100">
        <h1>Nicole Ziegler</h1>
         <p>
           Die Unterfränkin absolvierte nach dem Abitur zunächst eine Ausbildung als Industriekauffrau mit dem Schwerpunkt Marketing, Planung und Logistik und sammelte erste Berufserfahrung in der Automotive- und Kunststoffverarbeitungsindustrie. Anschließend ergänzte sie ihre Kenntnisse um ein Studium der Betriebswirtschaftslehre, das auf die Schwerpunkte Marketing, Vertrieb und Personal ausgelegt war. Es folgten mehrere Jahre an Berufserfahrung in den Bereichen Produktmarketing, produzierende Industrie und Vertrieb im Sektor Automotive.
        </p>
        <p>
          In den folgenden Jahren erlangte Nicole Ziegler fundierte Kenntnisse als Teamleiterin in einer Unternehmensberatung mit den Schwerpunkten Digitalisierung, Projektmanagement und Finanzen sowie auf dem Gebiet des Bewerbermanagements, des Outsourcings und der kaufmännischen Prozesse. Zeitgleich erweiterte sie stetig ihren eigenen, persönlichen und spezialisierten Pool an Interim Managern.
        </p>
        <p>
          Nicole Ziegler liebt Herausforderungen. Sie brennt darauf, nach Lösungen für bisher nicht da gewesene Situationen zu suchen. Dafür investiert sie gern ihr gesamtes Know-how und ihre Passion für Projekte, Kooperationen, Innovationen und vor allem Menschen.
        </p>
      </div>
    </div>
    <div class="md-layout mt-10"
         style="margin-left:10vw; margin-right:10vw">
      <div class="md-layout-item mt-40 md-xlarge-size-40 md-large-size-40 md-medium-size-40 md-small-size-100 md-xsmall-size-100">
        <img src="../assets/about-henrik.jpg">
      </div>
      <div class="md-layout-item blog-margin md-xlarge-size-60 md-large-size-60 md-medium-size-60 md-small-size-100 md-xsmall-size-100">
        <h1>Henrik Deitinghoff</h1>
        <p>
          Aufgewachsen in Ostwestfalen-Lippe absolvierte Henrik Deitinghoff nach der schulischen Laufbahn zunächst eine Ausbildung als Industriekaufmann, ehe er sich dem Studium mit den Schwerpunkten Finanzen, Personal und Unternehmensführung widmete. In zahlreichen Auslandsaufenthalten in den USA, China und Australien sammelte er fundierte Kenntnisse in den Bereichen internationales Produktmanagement, Controlling und Consulting.
        </p>
        <p>
          Es folgten zahlreiche weitere Jahre an Berufserfahrung, in denen sich Henrik Deitinghoff vorrangig mit Bereichen wie Einkauf und HR, Management, Finanzen und Personalberatung beschäftigte. Weitere Tätigkeitsfelder beinhalteten die Strukturierung des Vertriebs, die Ausbildung von Mitarbeitern, die Neukundengewinnung sowie diverse kaufmännische Themenstellungen. 
        </p>
        <p>
          Henrik Deitinghoff liebt Effizienz und modernes Arbeiten und stellt sich gern fehlerbehafteten Sachverhalten, aus denen es keinen Ausweg zu geben scheint. Sein Steckenpferd ist der prozessgetriebene Vertrieb nach 4.0, in den er seine Begeisterung für Innovation, Kreativität und Optimierungspotenzial steckt.
        </p>
      </div>
    </div>
    <div class="md-layout mt-100"
         style="margin-left:10vw; margin-right:10vw;">
      <h1>Unsere Expertise</h1>
    </div>
    <div class="md-layout mt-10"
         style="margin-left:10vw; margin-right:10vw">
      <div class="md-layout-item md-xlarge-size-40 md-large-size-40 md-medium-size-40 md-small-size-100 md-xsmall-size-100">
        <h1>Wie unsere Experten Ihr Unternehmen vorantreiben</h1>
        <p>
          naniungo unterstützt Unternehmen aller Branchen, Herausforderungen zu lösen und Prozesse effizienter zu gestalten. Wir helfen Ihnen, Ihre Organisation optimal aufzustellen. Unsere Beraterteams versetzen sich in Ihre Lage und erarbeiten mit Ihnen gemeinsam maßgeschneiderte Lösungen. Wir sind ein dynamisches Team aus kreativen Köpfen, das zielorientiert auf den Erfolg unserer Kunden zugeht. Die Mannschaft besteht aus persönlichkeitsstarken Experten auf unterschiedlichen Fachgebieten. Neben Marketing und Supply Chain Management bilden sowohl IT- und Finanzfachleute als auch Spezialisten in den Bereichen digitale Transformation und Projekt- und Prozessmanagement das Team von naniungo. 
        </p>
        <p>
          Hinter dem Erfolg von naniungo stehen branchenführende Experten, ein geballtes Netzwerk an Know-how und Erfahrung. Mit Expertise und Energie helfen sie unseren Kunden, sich auf das Wesentliche zu konzentrieren und eine starke Organisation aufzubauen.
        </p>
        <p>
          Ob bei personellen Engpässen oder Beratungsthemen - Sie stehen für uns an erster Stelle! Mit hohem Engagement und Ehrgeiz unterstützen wir Sie bei Ihren Fragestellungen. Ihre Herausforderung wird zu unserer. In enger Zusammenarbeit entwickeln wir Ihre Organisation Schritt für Schritt weiter.
        </p>
      </div>
      <div class="md-layout-item blog-margin md-xlarge-size-60 md-large-size-60 md-medium-size-60 md-small-size-100 md-xsmall-size-100">
        <img src="../assets/naniungo-slide-20.jpg">
      </div>
    </div>
    <div class="md-layout mt-100"
         style="margin-left:10vw; margin-right:10vw">
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-20 md-small-hide md-xsmall-hide">
      </div>
      <div class="md-layout-item md-xlarge-size-60 md-large-size-60 md-medium-size-60 md-small-size-100 md-xsmall-size-100">
        <h1>Welche Vorteile haben Sie durch naniungo? </h1>
        <p>
          Mit uns haben Sie einen starken Partner an Ihrer Seite, der individuell auf die Bedürfnisse Ihres Unternehmens, Ihrer Prozesse und Ihrer Projekte eingeht. Wir legen unser gesamtes Herzblut in jedes unserer Projekte und versuchen stets, noch besser zu sein. Unsere große Stärke ist unsere Loyalität mit unseren Kunden und unseren Experten! Aufgrund unserer langjährigen Berufserfahrung vereinen wir zahlreiche Bereiche und schaffen dadurch einzigartige Verknüpfungen. Wir identifizieren uns mit unseren Kunden und versetzen uns in deren Situation. Zurückgreifend auf unser kompetentes Team aus Experten finden wir höchsteffektive Lösungsstrategien für Ihr Unternehmen.
        </p>
      </div>
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-20 md-small-hide md-xsmall-hide">
      </div>
    </div>
    <div class="message dark secondary mt-40">
      <router-link style="width:100%;"
                   v-bind:to="'/themen'" exact>
        <h1>unsere Themenschwerpunkte<md-icon class="green ml-20">arrow_forward</md-icon>
        </h1>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "About",
  data() {
    return {
      firstName: "",
      lastName: "",
      jobTitle: "",
      emailAddressPrivate: "",
      phoneNumberBusiness: "",
      hobbies: "",
      ambition: "",
      level: "",
      function: "",
      carerix_id: "",
      functionOne: "",
      method: "",
      varCandidates: [
        {
          ambition: "",
          isOpen: false,
          addtoCart: false,
          carerix_id: ""
        }
      ]
    };
  },
  computed: {
    ...mapState({
      candidates: state => state.candidates.candidates,
      cart: state => state.cart.cart
    })
  },
  created() {
    // this.$store.dispatch('candidates/getCandidates');
  },
  methods: {
    ...mapActions("candidates", "cart", [
      "addCandidate",
      "deleteCandidate",
      "updateCandidate",
      "getCart"
    ]),
    toggleOpen(value) {
      var item = this.varCandidates.filter(obj => {
        return obj.ambition === value;
      })[0];

      if (typeof item !== "undefined") {
        item.isOpen = !item.isOpen;
      }
    },
    getToggleState(value) {
      const item = this.varCandidates.filter(obj => {
        return obj.ambition === value;
      })[0];
      if (typeof item !== "undefined") {
        return item.isOpen;
      }
    },
    toggleCart(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter(obj => {
        return obj.ambition === value;
      })[0];
      if (typeof item !== "undefined") {
        item.addtoCart = !item.addtoCart;
      }
    },
    getCartState(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter(obj => {
        return obj.ambition === value;
      })[0];
      if (typeof item !== "undefined") {
        return item.addtoCart;
      }
    }
  },
  mounted() {
    // if (localStorage.getItem('toggle') === 'true' && localStorage.getItem('toggle').length ===  this.$store.state.candidates.candidates.length) {
    if (localStorage.getItem("varCandidates")) {
      this.varCandidates = JSON.parse(localStorage.getItem("varCandidates"));
    } else {
      for (var i in this.$store.state.candidates.candidates) {
        var item = this.$store.state.candidates.candidates[i];
        this.varCandidates.push({
          ambition: item.ambition,
          isOpen: false,
          addtoCart: false,
          carerix_id: item.carerix_id
        });
      }
    }
  },
  watch: {
    varCandidates: {
      handler() {
        localStorage.setItem(
          "varCandidates",
          JSON.stringify(this.varCandidates)
        );
        this.$store.dispatch("cart/getCart");
        // this.getCart();
      },
      deep: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/shared.scss";
.bg-1 {
  background: url("../assets/naniungo-2.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 500px;
}
.profiles {
  margin-left: 10px;
  margin-right: 10px;

  .md-card-header {
    padding: 16px;
  }

  .md-card {
    margin: 10px;
    width: 55vw;
    display: inline-block;
    vertical-align: top;
  }

  // .md-layout{
  //   margin-left:10vw !important;
  //   margin-right:10vw !important;
  // }

  @media (min-width: 300px) and (max-width: 1300px) {
    .md-card {
      width: 50vw;
    }
  }

  .md-title {
    // margin-right:80px !important;
    h3 {
      font-size: 30px !important;
      margin-top: -2px;
      font-weight: 900;
    }
  }
  .md-subhead {
    // margin-right:80px !important;
    p {
      font-size: 16px !important;
      color: $primary-font;
    }
  }
  .md-card-actions {
    margin-bottom: 5px;
    margin-right: 5px;
  }
}
</style>
